//@ts-check
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '../../core/Button';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      position: 'fixed',
      bottom: 0,
      right: 0,
      marginRight: 20,
      marginBottom: -2,
      zIndex: 9999,
      backgroundColor: 'white'
    }
  };
}, {
  name: 'ECAIButton'
});

var AIButton = function AIButton(_ref) {
  var onClick = _ref.onClick;
  var classes = useStyles({});
  return React.createElement("div", {
    className: classes.root
  }, React.createElement(Button, {
    variant: "outlined",
    color: "default",
    icon: ":favorites",
    onClick: onClick
  }, "AI"));
};

AIButton.defaultProps = {};
export default AIButton;